import { useMutation } from '@tanstack/react-query';
import { useToast } from 'app-context/toasterContext/ToastContext';
import axios from 'axios';
import { API_URL } from 'constants';
import { cleanToken } from 'utils';

const postData = async (
  url,
  data = null,
  method = 'post',
  isFormData = false,
  requiresAuth = true,
  baseUrl
) => {
  const headers = {
    ...(requiresAuth &&
      localStorage.getItem('token') && {
        Authorization: `Bearer ${cleanToken(localStorage.getItem('token'))}`,
      }),
    ...(isFormData ? { 'Content-Type': 'multipart/form-data' } : {}),
  };

  try {
    const response = await axios({
      method,
      url: `${baseUrl ?? API_URL ?? ''}${url}`,
      data,
      headers,
    });
    console.log('ssssssssssssss12', response);

    return response;
  } catch (error) {
    throw error;
  }
};

export const usePost = (options = {}) => {
  const toast = useToast();
  return useMutation({
    mutationFn: async ({
      data = null,
      method = 'post',
      isFormData = false,
      requiresAuth = true,
      url,
      baseUrl,
    }) => postData(url, data, method, isFormData, requiresAuth, baseUrl),
    onSuccess: (data) => {
      const userMessage = data?.data?.userMessage || '';
      const isSuccess = data?.data?.isSuccess;
      console.log('ssssssssssssss10', data, options);
      if (isSuccess === true && !options.onSuccessToast) {
        toast.open(userMessage || 'Success', 'add');
      } else if (isSuccess === false) {
        toast.open(userMessage || 'Something went wrong', 'error');
      } else {
        if (options.onSuccessToast)
          toast.open(options.onSuccessToast, options.toastType);
      }
    },
    onError: (error) => {
      console.log('ssssssssssssss11', error);

      const userMessage =
        error?.response?.data?.message ||
        'Something went wrong, Please try again.';
      toast.open(userMessage, 'error');
    },
    ...options,
  });
};
